import React from "react";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "react-responsive";
import "../styles/PorqueElegirnos.scss";
import id1 from "../images/identificadores/1.svg";
import id2 from "../images/identificadores/2.svg";
import id3 from "../images/identificadores/3.svg";
import id4 from "../images/identificadores/4.svg";
import id5 from "../images/identificadores/5.svg";

const PorqueElegirnos = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  let velFade = 2000;

  const tarjetas = [
    {
        id: 1,
        imagen: id1,
        titulo: 'Inglés Real',
        texto: 'Aprende inglés de verdad con práctica conversacional y entrenamiento auditivo desde el primer día. Desarrolla fluidez, comprensión y confianza al hablar.',
    },
    {
        id: 2,
        imagen: id2,
        titulo: 'Grupos Reducidos',
        texto: 'Estudia en grupos pequeños con atención personalizada y seguimiento cercano, ideal para avanzar rápido con apoyo de profesores calificados.',
    },
    {
        id: 3,
        imagen: id3,
        titulo: 'Horarios Flexibles',
        texto: 'Nuestros cursos se adaptan a agendas ocupadas y turnos rotativos, permitiéndote aprender inglés sin afectar tu rutina y sin perder calidad.',
    },
    {
        id: 4,
        imagen: id4,
        titulo: 'Mejor Inversión',
        texto: 'Ofrecemos el mejor costo-beneficio: formación profesional, clases dinámicas y resultados que convierten tu aprendizaje en una inversión para tu futuro.',
    },
    {
        id: 5,
        imagen: id5,
        titulo: 'Resultados Rápidos',
        texto: 'Con nuestro método comprobado hablarás inglés fluido en 8 meses, con clases prácticas, material incluido y evaluaciones que garantizan tu progreso.',
    },
  ];

  return (
    <section className="text-center" id="porqueE">
      <center>
        <Fade>
          <br/><h4 className="fw-bold fs-3 titlePorqueE">
            ¿POR QUÉ ELEGIRNOS?
          </h4>
        </Fade>
      </center>
      <div className="containerCards">
            {tarjetas.map((tarjeta) => (
                <div key={tarjeta.id} className="containerCard text-center">
                    {isMobile && (
                        <Fade duration={velFade}>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </Fade>
                    )}
                    {!isMobile && (
                        <div>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </div>
                    )}
                </div>
            ))}
      </div>
      <br/><br/><br/>
    </section>
  );
};

export default PorqueElegirnos;
